import React, { useState, useEffect } from "react";
import Header from "./../js/header.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/csOpenIPO.css";
import { getOpenIpoListApi, removeCounterRateApi } from "../api/csOpenIPOApi.js";
import Slider from "../components/Slider";
import CounterRateSlider from "../components/CounterRateSlider";

const CsOpenIPO = () => {
  const [loader, setLoader] = useState("none");
  const [quoteWvrId, setQuoteWvrId] = useState(0);
  const [slider, setSlider] = useState(false);
  const [weaverRate, setWeaverRate] = useState(0);
  const [counterRate, setCounterRate] = useState(0);
  const [lstOpenIPO, setLstOpenIPO] = useState([]);
  const [results, setResults] = useState([]);
  const [parentCompanyNm, setParentCompanyNm] = useState("");
  const [designNoColor, setDesignNoColor] = useState("");
  const [weaverNm, setWeaverNm] = useState("");
  const [ipoNo, setIpoNo] = useState("");

  useEffect(() => {
    
    getOpenIpoList();
  }, []);
  function getOpenIpoList(){
    setLoader("block");
    getOpenIpoListApi(cbGetOpenIpoList)
  }
  function cbGetOpenIpoList(data) {
    setLoader("none");
    if (data.status === "Success") {
      console.log(data);
      setLstOpenIPO(data.lstOpenIPO);
      setResults(data.lstOpenIPO);
    } else {
      toast.error(data.message);

      if (data.message === "You are not logged in") {
        window.location.href = window.CSURL;
      }
    }
  }
  function removeCounterRate() {
    var r = window.confirm("Are you sure to remove the counter rate?");
    if (r) {
      removeCounterRateApi(quoteWvrId, cbCounterRate);
    }
  }

  function cbCounterRate(data) {
    setLoader("none");
    if (data.status === "Success") {
      toast.success(data.message);
      getOpenIpoList();
    } else {
      toast.error(data.message);
      if (data.message === "You are not logged in") {
        window.location.href = window.CSURL;
      }
    }
  }

  function closeSlider() {
    // e.preventDefault();
    document.querySelector(".main").classList.remove("addOpacity");
    setSlider(false);
  }

  function openSlider() {
    // e.preventDefault();
    document.querySelector(".main").classList.add("addOpacity");
    setSlider(true);
  }
  function filterFn() {
    var tmpLst = [];
    for (var i = 0; i < lstOpenIPO.length; i++) {
      var obj = lstOpenIPO[i];

      if (ipoNo !== "" && !obj.ipoNo.toLowerCase().includes(ipoNo)) {
        continue;
      }
      if (weaverNm !== "" && !obj.weaverNm.toLowerCase().includes(weaverNm)) {
        continue;
      }
      if (
        designNoColor !== "" &&
        !obj.designNoColor.toLowerCase().includes(designNoColor)
      ) {
        continue;
      }
      if (
        parentCompanyNm !== "" &&
        !obj.parentCompanyNm.toLowerCase().includes(parentCompanyNm)
      ) {
        continue;
      }
      tmpLst.push(obj);
    }
    setResults(tmpLst);
  }
  async function filterCompany(e) {
    const keyword = e.target.value;
    await setParentCompanyNm(keyword);
    filterFn()
    
  }

  async function filterDsnColor(e) {
    const keyword = e.target.value;
    /* if (keyword !== "") {
      const data = results.filter((obj) => {
        return obj.designNoColor.toLowerCase().includes(keyword.toLowerCase());
      });
      setResults(data);
    } else {
      setResults(lstOpenIPO);
    } */

    await setDesignNoColor(keyword);
    filterFn()
  }

  async function filterWvr(e) {
    const keyword = e.target.value;
    await setWeaverNm(keyword);
    filterFn()
  }

  async function filterIpoNo(e) {
    const keyword = e.target.value;
    await setIpoNo(keyword);
    filterFn()
  }

  return (
    <div style={{ height: "100%" }}>
      <Header />
      <ToastContainer autoClose={2000} hideProgressBar />
      <div
        style={{
          position: "fixed",
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: loader,
          zIndex:1
        }}
      >
        <img src={require("../images/loader.gif")} alt="Loader..." />
      </div>
      <div
        className="main"
        style={{ pointerEvents: loader === "none" ? "auto" : "none" }}
      >
        <div className="container-fluid">
          <div className="col-sm-11 col-centered">
            <table
              className="tableLayout1"
              style={{ width: "calc(100% - 17px)" }}
            >
              <thead>
                <tr>
                  <th style={{ width: 5, display: "none" }}>Quote Weaver Id</th>
                  <th style={{ width: 30 }}>IPO Id</th>
                  <th style={{ width: 40 }}>
                    <input
                      type="text"
                      className="form-control inp-search"
                      id="ipoNo"
                      placeholder="PO No."
                      onChange={filterIpoNo}
                      onKeyDown={filterIpoNo}
                    />
                  </th>
                  <th style={{ width: 35 }}>Created On</th>
                  <th style={{ width: 80 }}>
                    <input
                      type="text"
                      className="form-control inp-search"
                      id="weaver"
                      placeholder="Weaver"
                      onChange={filterWvr}
                      onKeyDown={filterWvr}
                    />
                  </th>
                  <th style={{ width: 80 }}>
                    <input
                      type="text"
                      className="form-control inp-search"
                      id="designNoColor"
                      placeholder="Design Color"
                      onChange={filterDsnColor}
                      onKeyDown={filterDsnColor}
                    />
                  </th>
                  <th style={{ width: 70 }}>
                    <input
                      type="text"
                      className="form-control inp-search"
                      id="parentCompanyNm"
                      placeholder="Company"
                      onChange={filterCompany}
                      onKeyDown={filterCompany}
                    />
                  </th>
                  <th style={{ width: 35 }}>Weaver Rate</th>
                  <th style={{ width: 35 }}>Counter Rate</th>
                  <th style={{ width: 35 }}>Countered On</th>
                  <th style={{ width: 30 }}>Action</th>
                </tr>
              </thead>
            </table>
            <div className="openIpoTableDiv col-sm-12 col-xs-11 padding-remove">
              <table id="openIpoTable" className="tableLayout">
                <colgroup>
                  <col width="30" />
                  <col width="40" />
                  <col width="35" />
                  <col width="80" />
                  <col width="80" />
                  <col width="70" />
                  <col width="35" />
                  <col width="35" />
                  <col width="35" />
                  <col width="30" />
                </colgroup>
                <tbody id="openIpoTableBody">
                  {results.map((obj, i) => {
                    return (
                      <tr key={i}
                        className={
                          obj.quoteWeaverId === quoteWvrId ? "selected" : ""
                        }
                        onClick={(e) => {
                          console.log(obj);
                          setQuoteWvrId(obj.quoteWeaverId);
                          setWeaverRate(obj.weaverRate);
                          setCounterRate(obj.counterRate);
                        }}
                      >
                        <td>{obj.ipoId}</td>
                        <td>{obj.ipoNo}</td>
                        <td className="text-center">{obj.ipoCreatedDt}</td>
                        <td>{obj.weaverNm}</td>
                        <td>{obj.designNoColor}</td>
                        <td>{obj.parentCompanyNm}</td>
                        <td className="text-right">{obj.weaverRate}</td>
                        <td className="text-right">{obj.counterRate}</td>
                        <td className="text-center">{obj.counterOn}</td>
                        <td className="text-center">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-around",
                            }}
                          >
                            <span
                              onClick={(e) => openSlider(e)}
                              className="glyphicon glyphicon-edit"
                              style={{ cursor: "pointer" }}
                            ></span>
                            <span
                              className="glyphicon glyphicon-remove"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => removeCounterRate()}
                            ></span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Slider
        width="70%"
        slider={slider}
        closeSlider={closeSlider}
        heading="Add/Edit Counter Rate"
      >
        <CounterRateSlider
          key={`${quoteWvrId}_${weaverRate}_${counterRate}`}
          width="70%"
          quoteWeaverId={quoteWvrId}
          weaverRate={weaverRate}
          counterRate={counterRate}
          closeSlider={closeSlider}
          getOpenIpoList={getOpenIpoList}
        />
      </Slider>
    </div>
  );
};

export default CsOpenIPO;
